import React from 'react';

interface FilterControlsProps {
  sortBy: string;
  onSortChange: (sortBy: string) => void;
  minPrice: number;
  onMinPriceChange: (price: number) => void;
  minMarketCap: number;
  onMinMarketCapChange: (marketCap: number) => void;
}

export default function FilterControls({
  sortBy,
  onSortChange,
  minPrice,
  onMinPriceChange,
  minMarketCap,
  onMinMarketCapChange
}: FilterControlsProps) {
  return (
    <div className="bg-gradient-to-br from-bg-secondary to-bg-tertiary rounded-3xl p-6 mb-8 flex gap-6 flex-wrap items-end shadow-bubble border-2 border-primary/10">
      <div className="flex flex-col gap-3 flex-1 min-w-[180px]">
        <label htmlFor="sortSelect" className="text-text-secondary text-sm font-bold uppercase tracking-wider flex items-center gap-2">
          <span>🔀</span> Sort by:
        </label>
        <select
          id="sortSelect"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          className="px-5 py-3.5 bg-bg border-2 border-border rounded-full text-text text-base font-medium transition-all duration-300 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/20 focus:shadow-bubble cursor-pointer hover:border-primary/50"
        >
          <option value="market_cap">📈 Market Cap</option>
          <option value="price">💰 Price</option>
          <option value="name">🔤 Name (A-Z)</option>
          <option value="change24h">📊 24h Change</option>
          <option value="utility">⚡ Utility</option>
        </select>
      </div>
      <div className="flex flex-col gap-3 flex-1 min-w-[180px]">
        <label htmlFor="filterPrice" className="text-text-secondary text-sm font-bold uppercase tracking-wider flex items-center gap-2">
          <span>💵</span> Min Price ($):
        </label>
        <input
          type="number"
          id="filterPrice"
          step="0.01"
          min="0"
          placeholder="0.01"
          value={minPrice || ''}
          onChange={(e) => onMinPriceChange(parseFloat(e.target.value) || 0)}
          className="px-5 py-3.5 bg-bg border-2 border-border rounded-full text-text text-base font-medium transition-all duration-300 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/20 focus:shadow-bubble placeholder:text-text-secondary/50"
        />
      </div>
      <div className="flex flex-col gap-3 flex-1 min-w-[180px]">
        <label htmlFor="filterMarketCap" className="text-text-secondary text-sm font-bold uppercase tracking-wider flex items-center gap-2">
          <span>🎯</span> Min Market Cap ($):
        </label>
        <select
          id="filterMarketCap"
          value={minMarketCap}
          onChange={(e) => onMinMarketCapChange(parseInt(e.target.value))}
          className="px-5 py-3.5 bg-bg border-2 border-border rounded-full text-text text-base font-medium transition-all duration-300 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/20 focus:shadow-bubble cursor-pointer hover:border-primary/50"
        >
          <option value="0">🌟 All Coins</option>
          <option value="1000000">💰 $1M+</option>
          <option value="10000000">💎 $10M+</option>
          <option value="50000000">🚀 $50M+</option>
          <option value="100000000">⭐ $100M+</option>
          <option value="500000000">💫 $500M+</option>
          <option value="1000000000">👑 $1B+</option>
        </select>
      </div>
    </div>
  );
}

